// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: 'roles/powerbi',
  component: () => import('modules/powerbi/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Controle GU',
            name: 'IconListGU'
          },
          {
            text: 'Dashboards',
            name: 'IconListRoles'
          }
        ]
      },
      name: 'IconListRoles',
      component: () => import('modules/powerbi/IconListRoles.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.management.gu.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'lastaccessuser',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Controle GU',
            name: 'IconListGU'
          },
          {
            text: 'Dashboards',
            name: 'IconListRoles'
          },
          {
            text: 'Gestão de Usuários',
            name: 'LastAccessUser'
          }
        ]
      },
      name: 'LastAccessUser',
      component: () => import('modules/powerbi/LastAccessUser'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.management.gu.active.users')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'accesscontroldepartmentalsystems',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Controle GU',
            name: 'IconListGU'
          },
          {
            text: 'Dashboards',
            name: 'IconListRoles'
          },
          {
            text: 'Controle de Acessos e Sistemas Departamentais',
            name: 'AccessControlDepartmentalSystems'
          }
        ]
      },
      name: 'AccessControlDepartmentalSystems',
      component: () => import('modules/powerbi/AccessControlDepartmentalSystems'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.management.gu.active.users')) {
          next();
        } else {
          next('/');
        }
      }
    },
  ]
};
